import { amber, grey } from '@mui/material/colors';
import { createTheme, PaletteMode } from '@mui/material';

declare module '@mui/material/styles' {
    interface Palette {
        customBackground: Palette['primary'];
        iconInner: Palette['primary'];
        navBackground: Palette['primary'];
        buttonBackground: Palette['primary'];

    }

    interface PaletteOptions {
        customBackground: PaletteOptions['primary'];
        iconInner: PaletteOptions['primary'];
        navBackground: PaletteOptions['primary'];
        buttonBackground: PaletteOptions['primary'];

    }
}

export const customTheme = createTheme({
    palette: {
        // palette values for light mode
        primary: {main: "#D1E9FC"},
        // divider: amber[200],
        text: {
            primary: grey[900],
            secondary: grey[800],
        },

        customBackground: {
            // main: "#F4F5FA",
            main: "white"
            // main: "#121212"

        },
        iconInner: {
            main: "#FFFFFF"
        },
        navBackground: {
            main: "#F4F5FA"
        },
        buttonBackground: {
            main: "white"
            // main: "#D1E9FC"

        }

    }
});

